import { Sprite } from 'pixi.js';
import { createPixiText, scaleToFit } from '../../Utils/Utils';
import Core from '../../Core/Core';

export class FreeBooster extends Sprite {
    constructor(width: number, height: number) {
        super();

        const bg = new Sprite(PIXI.utils.TextureCache['gameui/booster-cost-bg']); // names will change when we have final graphics
        bg.anchor.set(0.5, 0.5);
        bg.scale.set(scaleToFit(bg.width, bg.height, width, height));

        const txt = createPixiText(
            Core.local.getText('free'),
            new PIXI.Rectangle(width * 0.15, 0, width * 10, height),
            'Baloo',
            20,
            10,
            0xffffff
        );
        txt.scale.set(scaleToFit(txt.width, txt.height, bg.width * 0.6, bg.height * 0.5));
        this.addChild(bg, txt);
    }
}
